<template>
  <div class="">
    <div class="col-md-12 ">
    <draggable v-model="groupsData" handle=".handle" @end="onEnd">
      <transition-group>
        <div v-for="(group, idx) in groupsData" :key="group.id" class="homepage-div"  >
          <div class="homepage-banner" :class=" group.visibility ? 'selected-group' : ''" @click="toggleVisibility(idx, $event)">
              <div class="group-header"  >
                <span class="handle" style="max-width:10px"><i class="fa fa-align-justify "></i></span>
                <span class="group_name">{{group.name}}</span>
                <span>{{group.display ? group.display : 0}}</span>
                <span>
                  <template>
                    <p-switch type="success" v-model="group.active" @input="handleActiveGroup(group)" class="switch"></p-switch>
                  </template>
                </span>
                <span >
                  <div class="edit" @click="editGroup(group, idx)">
                      <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                    </div>
                  <a class="btn delete" @click="deleteGroup(group.id, group.name, idx)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                </span>
              </div>
              <div class="banner-action">
                <i :class="group.visibility ? 'fa fa-angle-down' : 'fa fa-angle-right'"></i>
                <!-- <button class="btn btn-dark btn-icon2"></button> -->

              </div>
          </div>
          <!-- show banners for this -->
          <div class="banners-table" v-show="group.visibility" :ref="'banners_table_'+group.id">
            <div class="banner-div">
              <div class="pull-right ">
                <router-link class="btn btn-icon btn-info add mar-bt-20" :to="{ path: '/marketing/offers/'+group.id+'/add-group-banner'}" :title="$t('general.add') + ' ' + $t('marketingOffers.single')">
                  <img src="/static/img/icons/add.png">
                  {{ $t('general.add') }}
                </router-link>
              </div>
              <table class="table width-table" ref="sortableTable">
                <thead>
                      <tr>
                        <th width="5%"></th>
                        <th width="10%">{{$t('marketingOffers.image')}}</th>
                        <th width="20%">{{$t('marketingOffers.title')}}</th>
                        <th width="10%">{{$t('marketingOffers.status')}}</th>
                        <th width="15%">{{$t('marketingOffers.linkType')}}</th>
                        <th width="20%">{{$t('marketingOffers.startEndDate')}}</th>
                        <th width="10%">{{$t('marketingOffers.actions')}}</th>
                        <th width="30%"></th>
                      </tr>
                </thead>
                <draggable v-model="group.banners" :element="'tbody'" @end="adjustSort">
                  <template v-for="(item, index) in group.banners">
                    <tr class="sortableRow" :key="item.id">
                      <td >
                        <i style="cursor: move" class="fa fa-arrows sortHandle"></i>
                      </td>
                      <td>
                        <div class="cell">
                          <div class="image-table">
                            <img v-bind:src="(item.image)?item.image : ''" />
                          </div>
                        </div>
                      </td>
                      <td>{{ item.title }}</td>
                      <td>
                        <template>
                          <p-switch v-model="item.active" type="success" @input="handleActive(item)"></p-switch>
                        </template>
                      </td>
                      <td>{{ item.link_type }}</td>
                      <td> {{formatDate(item.date_start)}} - {{formatDate(item.date_end)}}</td>
                      <td>
                        <a class="btn btn-icon btn-danger" @click="handleDelete(index, item, idx, $event)" :title="$t('general.delete')"> <i class="ti-close"> </i></a>
                      </td>
                      <td class="edit-icon-pointer" @click="goToRecord(group.id, item.id)">
                        <div class="edit">
                          <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                        </div>
                      </td>
                    </tr>
                  </template>
                </draggable>
              </table>
            </div>
          </div>
        </div>
      </transition-group>
    </draggable>

      <vmodal name="groupModal"
          title="groupModal"
          class="groupModal"
          width="70%"
          :maxWidth="800"
          :minWidth="200"
          height="40%"
          :adaptive="true"
        >
        <form>
        <div class="header border-bottom">
          <h4 >{{$t('marketingOffers.addGroup')}}</h4>
        </div>
          <div class="content-group" >
            <div class="content_scrool">
              <div class="form-group">
                <label for="group_name">{{$t('marketingOffers.title')}}</label>
                <input type="text" v-validate="groupValidations.group_name" name="title" class="form-control" id="group_name" v-model="group.name" />
                <small class="text-danger" v-if="errors.has('title')">
                  {{ getError('title') }}
                </small>
              </div>
              <div class="form-group">
                <label for="group_display">{{$t('marketingOffers.display')}}</label>
                <select class="form-control" id="group_display" v-model="group.display" name="display" v-validate="groupValidations.group_display">
                  <option value="1X">1X</option>
                  <option value="2X">2X</option>
                  <option value="3X">3X</option>
                </select>
                <small class="text-danger" v-if="errors.has('display')">
                  {{ getError('display') }}
                </small>
              </div>
            </div>
          </div>
        <div class="groupModal__footer">
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save" @click.prevent="validate" :title="$t('general.save')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </div>
        </form>
      </vmodal>
    </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable
    },
    watch: {
      homepage (newValue, oldValue) {
        this.homepageText = newValue === true ? this.$t('marketingOffers.offers') : this.$t('marketingOffers.banners')
        this.updateHomepage(newValue)
      },
      triggerModal (newValue, oldValue) {
        this.addGroup()
      }
    },
    computed: {
    },
    props: {
      triggerModal: {
        type: Boolean
      }
    },
    data () {
      return {
        loading: true,
        homepage: this.$session.get('selectedCompanyData')['homepage'],
        homepageText: '',
        selected_group_idx: null,
        group: {
          id: '',
          name: '',
          display: '',
          status: ''
        },
        current_group: 0,
        actionCol: {
          label: 'Delete',
          props: {
            align: 'center'
          },
          buttons: [{
            props: {
              type: 'danger',
              icon: 'el-icon-delete',
              class: 'btn btn-orange btn-fill'
            },
            handler: (index, row) => {
              this.handleDelete(index, row)
            },
            label: 'delete'
          }]
        },
        paginationDef: {
          pageSize: 999,
          currentPage: 1,
          pageSizes: [999],
          show: false,
          disabled: true
        },
        searchQuery: '',
        propsToSearch: ['name', 'status', 'type', 'discount'],
        tableColumns: [],
        groupsData: [],
        filters: [
          {
            value: '',
            prop: ['title', 'link_type', 'date_start', 'date_end']
          }
        ],
        groupValidations: {
          group_name: {
            required: true
          },
          group_display: {
            required: true
          }
        }
      }
    },
    created () {
      this.initPage()

      this.$bus.$on('refresh', this.handleRefresh)
    },
    // mounted () {
    //   this.$bus.$on('refresh', this.handleRefresh)
    // },
    beforeDestroy () {
      this.$bus.$off('refresh', this.handleRefresh)
    },
    methods: {
      handleRefresh () {
        this.initPage()
      },
      initPage () {
        this.$nextTick(() => {
          this.loading = true
        })

        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          use_sort_order: 'asc'
        }

        this.getOffers(data)
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.errors.clear()
            this.saveGroup()
          }
        })
      },
      onEnd (evt) {
        if (this.groupsData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            // console.warn('first')
            before = 0
            after = this.groupsData[idx + 1].sort_order
          } else if ((idx + 1) === this.groupsData.length) {
            // console.warn('last')
            before = this.groupsData[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            // console.warn('middle')
            before = this.groupsData[idx - 1].sort_order
            after = this.groupsData[idx + 1].sort_order
          }

          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.groupsData[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }

          this.apiRequest('/homepage-offer/update-group/' + id, 'PUT', data, (response) => {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: this.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      },
      toggleVisibility (idx, event) {
        if (!this.ignoreToggle(event)) return false

        this.groupsData[idx].visibility = !this.groupsData[idx].visibility
        this.current_group = idx
      },
      ignoreToggle (event) {
        // let check = event.path[0].classList.contains('fa-pencil') || event.path[0].classList.contains('bootstrap-switch-default') || event.path[0].classList.contains('bootstrap-switch-label') || event.path[0].classList.contains('fa-trash') || event.path[0].classList.contains('btn')
        let check = event.srcElement.className === 'fa fa-angle-right' || event.srcElement.className === 'fa fa-angle-down' || event.srcElement.className === 'group_name'
        return check
      },
      getOffers (data) {
        this.apiRequest('/homepage-offer', 'GET', data, (response) => {
          if (response.status === true) {
            this.groupsData = response.data
            let active = parseInt(this.$route.query.active)
            if (active) {
              this.groupsData.forEach((el, idx) => {
                if (el.id === active) {
                  el.visibility = 1
                  this.current_group = idx
                }
              })
            }
          }
          this.$nextTick(function () {
            this.loading = false
          })
        })
      },
      addGroup () {
        this.emptyModal()
        this.$modal.show('groupModal')
      },
      saveGroup () {
        let data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          id: this.group.id,
          name: this.group.name,
          display: this.group.display
        }
        this.apiRequest('/homepage-offer/add', 'POST', data, (response) => {
          if (response.status) {
            this.getOffers(data)
            this.emptyModal()
            this.$modal.hide('groupModal')
            swal(
              this.$t('general.success') + '!',
              this.$t('marketingOffers.offerSuccess'),
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      editGroup (data, idx) {
        this.$modal.show('groupModal')
        // change text -> to do ca e si translate
        // populate fields
        this.group.id = data.id
        this.group.name = data.name
        this.group.display = data.display
      },
      emptyModal () {
        this.group.id = ''
        this.group.name = ''
        this.group.display = ''
      },
      deleteGroup (id, name, idx) {
        var self = this

        event.stopPropagation()
        swal({
          text: self.$t('marketingCampaigns.areYouSureDelete') + ` '${name}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/homepage-offer/delete-group/' + id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingOffers.offerDeleted'),
                  'success'
                )
                self.groupsData.splice(idx, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
        })
      },
      handleActiveGroup (group) {
        let actionText = group.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${group.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: group.active ? 1 : 0,
              name: group.name,
              display: group.display,
              id: group.id
            }
            this.apiRequest('/homepage-offer/add', 'POST', data, (response) => {
              if (response.status) {
                swal(
                  this.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  this.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                group.active = !group.active
              }
            })
          }
        }).catch(() => {
          group.active = !group.active
        })
      },
      updateHomepage (option) {
        // update company option regarding homepage
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          option: option ? 1 : 0
        }
        this.apiRequest('/homepage-offer/update-company', 'POST', data, (response) => {
          if (response.status) {
            let selected = this.$session.get('selectedCompanyData')
            selected.homepage = option
            this.$session.set('selectedCompanyData', selected)
            swal(
              this.$t('general.success') + '!',
              'Optiune homepage updatata',
              'success'
            ).catch(() => {})
          } else {
            swal(
              '',
              this.$t('validations.wentWrong'),
              'error'
            ).catch(() => {})
          }
        })
      },
      handleActive (row) {
        let actionText = row.active ? this.$t('general.activate') : this.$t('general.deactivate')
        swal({
          text: this.$t('validations.areYouSureYouWantTo') + ` ${actionText} ${row.title}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes')
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              active: row.active ? 1 : 0,
              id: row.id
            }

            var self = this
            this.apiRequest('/homepage-offer/update-banner/' + row.id, 'PUT', data, function (response) {
              if (response.status) {
                swal(
                  self.$t('general.success') + '!',
                  '',
                  'success'
                ).catch(() => {})
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                ).catch(() => {})
                row.active = !row.active
              }
            })
          }
        }).catch(() => {
          row.active = !row.active
        })
      },
      goToRecord (group, banner) {
        this.$router.push('/marketing/offers/' + group + '/edit-group-banner/' + banner)
        // return false
        // if (column.label !== 'Actions' && column.label !== 'Status') {
        //   this.globalGoToRecord(row, event, column, '/marketing/offers/' + row.id + '/edit-group/')
        // }
      },
      adjustSort (evt) {
        if (this.groupsData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder
          let group = this.current_group
          if (idx === 0) {
            // console.warn('first')
            before = 0
            after = this.groupsData[group].banners[idx + 1].sort_order
          } else if ((idx + 1) === this.groupsData[group].length) {
            // console.warn('last')
            before = this.groupsData[group].banners[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            // console.warn('middle')
            before = this.groupsData[group].banners[idx - 1].sort_order
            after = this.groupsData[group].banners[idx + 1].sort_order
          }
          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.groupsData[group].banners[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }
          var self = this
          this.apiRequest('/homepage-offer/update-banner/' + id, 'PUT', data, function (response) {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: self.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      },
      handleDelete (index, row, idx, event) {
        var self = this

        event.stopPropagation()
        swal({
          text: self.$t('marketingCampaigns.areYouSureDelete') + ` '${row.title}'?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: self.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany')
            }
            this.apiRequest('/homepage-offer/delete-banner/' + row.id, 'DELETE', data, function (response) {
              if (response.status === true) {
                swal(
                  '',
                  self.$t('marketingOffers.offerDeleted'),
                  'success'
                )
                self.groupsData[idx].banners.splice(index, 1)
              } else {
                swal(
                  '',
                  self.$t('validations.wentWrong'),
                  'error'
                )
              }
            })
          }
        }).catch(() => {
        })
      }
    }
  }
</script>
<style scoped>
  .border-bottom {
    border-bottom: 1px solid #ccc;
  }
  .group-header {
    display:flex;
    margin-block: 5px;
    font-size: 1.6em;
    padding: 10px;
    border-right: 1px solid #ccc;
    /* border-radius: 4px; */
    justify-content: space-between !important;
    flex: 1 1 auto;
  }
  .content-group {
    margin: 10px 15px;
  }
  .groupModal__footer {
    /* border-top: 1px solid #ccc; */
    padding: 10px 15px;
  }
  .header {
    padding-left: 15px;
  }
  .d-none {
    display: none !important;
  }
  .banners-table {
    /* border: 1px solid #ccc; */
    border-radius: 4px;
    /* width: 98%; */
    /* margin-left: 2%; */
    animation: fadeIn 0.3s ease-in-out;
    margin-bottom: 10px;
    /* background-color: #f5f5f5; */
  }
  .selected-group {
    /* background-color: #e3e24c; */
    background-color: #E4E8F9;
    border-bottom: 1px solid #E4E8F9

  }
  .homepage-banner:hover{
    background-color: #E4E8F9;
  }
  .banner-div {
    padding:15px;
  }
  @keyframes fadeIn {
      0% {
          opacity: 0;
          transform: translateY(startYposition);
      }
      100% {
          opacity: 1;
          transform: translateY(endYposition);
      }
  }

  @keyframes fadeOut {
      0% {
          opacity: 1;
          transform: translateY(startYposition);
      }
      100% {
          opacity: 0;
          transform: translateY(endYposition);
      }
  }
  .btn-icon2>i {
    font-size: 1.6em;
  }
  .homepage-banner {
    display: flex;
    cursor: pointer;
  }
  .homepage-banner span {
    font-weight: 500;
    font-size: 18px;
    line-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  .homepage-banner span .edit{
    max-height: 46px;
    line-height: 18px;
  }
  .banner-action {
    align-self: center;
    /* border: 1px solid #ccc; */
    padding: 10px;
    border-radius: 4px;
    font-size: 1.6em;
  }
  .homepage-div {
    border: 1px solid #E8ECFF;
    border-radius: 11px;
    margin-bottom: 10px;
    background: #FBFCFF;
  }
  .homepage-div button.edit {
    padding: 2px 13px !important;
  }
  .group_name {
    min-width: 350px;
    max-width: 350px;
    width: 37%;
    font-size: 18px;
    line-height: 40px;
    font-weight: 400 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Offers/Group/Group.vue